import React from "react";

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: "default" | "secondary" | "outline" | "destructive";
}

export function Badge({
  className = "",
  variant = "default",
  ...props
}: BadgeProps) {
  const variants = {
    default:
      "border-transparent bg-brand-primary text-white hover:bg-brand-primary/80",
    secondary:
      "border-transparent bg-brand-secondary text-brand-grey hover:bg-brand-secondary/80",
    outline: "text-brand-grey border-brand-grey/20",
    destructive: "border-transparent bg-red-500 text-white hover:bg-red-500/80",
  };

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 ${variants[variant]} ${className}`}
      {...props}
    />
  );
}
